// Redux Slice for AI Service
import axiosInstance from "./axios.instance";

export const API_WHITELABEL_COMPANY = async (formData) => {
  try {
    const response = await axiosInstance.post("/whitelabel", formData);
    return response.data;
  } catch (error) {
    console.log("Error in API_WHITELABEL_COMPANY:", error);
    throw error;
  }
};


export const API_GET_WHITELABEL_COMPANY = async () => {
  try {
    const response = await axiosInstance.get("/whitelabel");
    return response.data;
  } catch (error) {
    console.log("Error in API_GET_WHITELABEL_COMPANY:", error);
    throw error;
  }
};
 
export const API_WHITELABEL_COMPANY_CONFIG = async (formData) => {
  try {
    const response = await axiosInstance.post("/whitelabelconfig/getCompanydetails", formData);
    return response.data;
  } catch (error) {
    console.log("Error in API_WHITELABEL_COMPANY:", error);
    throw error;
  }
};